import { 
  CultureHouseElement, 
  CultureHouseJSON, 
  CultureHouseElementJSON
} from '../types/CultureHouseTypes';

export default class CultureHouseSerializers {
  static toObject(payload: CultureHouseElementJSON): CultureHouseElement {
    return {
      resourceId: payload.resource_id,
      key: payload.key,
      pillarTitle: payload.pillar_title,
      pillarDescription: payload.pillar_description,
      surveyResults: {
        totalOverlap: payload.survey_results.total_overlap,
        questions: payload.survey_results.questions.map(question => ({
          methodItem: {
            title: question.method_item.title,
            scaleConfiguration: {
              labelLeft: question.method_item.scale_configuration.label_left,
              labelRight: question.method_item.scale_configuration.label_right
            }
          },
          results: {
            valueEmployees: question.results.value_employees,
            valueManagement: question.results.value_management,
            overlap: question.results.overlap
          }
        }))
      }
    };
  }

  static toObjects(payload: CultureHouseJSON): CultureHouseElement[] {
    return payload.culture_house.map(CultureHouseSerializers.toObject);
  }
}
